<script lang="ts">
  import clsx from "clsx";
  import { Check, Copy } from "lucide-svelte";

  import { analytics } from "$lib/analytics";
  import type { Variant } from "./CodeSample.svelte";

  export let source: string;
  export let page: string = "";
  export let variant: Variant = "default";

  let lastPress: number | null = null;

  async function handleClick() {
    if (page.length > 0) {
      analytics.track("Code Copied", {
        page: page,
      });
    }

    await navigator.clipboard.writeText(source);
    const time = Date.now();
    lastPress = time;
    setTimeout(() => {
      if (lastPress !== null && lastPress <= time) {
        lastPress = null;
      }
    }, 1000);
  }
</script>

<button
  class={clsx(
    "flex items-center leading-5 p-1 border transition-colors bg-dark-gray",
    variant === "minimal" ? "rounded-r" : "rounded",
    lastPress !== null
      ? "text-brand-green border-brand-green"
      : "text-zinc-200 border-white/20",
  )}
  on:click|stopPropagation={handleClick}
>
  {#if lastPress === null}
    <Copy class={variant === "minimal" ? "mx-2" : "ml-1"} size={16} />
    {#if variant === "default"}
      <span class="ml-1.5 pr-1 text-xs font-sans">Copy</span>
    {/if}
  {:else}
    <Check class={variant === "minimal" ? "mx-2" : "ml-0.5"} size={16} />
    {#if variant === "default"}
      <span class="ml-1.5 pr-1 text-xs font-sans">Copied</span>
    {/if}
  {/if}
</button>
